import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { bulkSaveCharterFeederPrices, fetchAllCharterFeederPrices } from '~/services/FlightsService';

import { charterFeederPricesQueryKeys } from './charterFeederPricesQueryKeys';

interface UseBulkSaveCharterFeederPricesOptions {
  onSuccess?: () => void | Promise<void>;
}

export function useGetCharterFeederPrices() {
  return useQuery({
    queryKey: charterFeederPricesQueryKeys.list(),
    queryFn: ({ signal }) => fetchAllCharterFeederPrices({ signal }),
    refetchOnWindowFocus: false,
  });
}

export function useBulkSaveCharterFeederPrices(options: UseBulkSaveCharterFeederPricesOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: bulkSaveCharterFeederPrices,
    onSuccess: async () => {
      await options.onSuccess?.();
      await queryClient.invalidateQueries({ queryKey: charterFeederPricesQueryKeys.all });
    },
  });
}
